module.exports = __webpack_public_path__ + "img/streak10.7ab4bd8f.png";